import { render, staticRenderFns } from "./EducationalCategoryCards.vue?vue&type=template&id=6b956eaf&"
import script from "./EducationalCategoryCards.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoryCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports